import {
  canViewAdminMenu,
  canViewCorePages,
  canViewLookups,
  canViewUserManagement
} from "@/utils/permissions";

export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
    i18n: "Home",
    //show: canViewAdminMenu()
    show: true
  },
  {
    url: "/user",
    name: "Users",
    slug: "Users",
    icon: "UsersIcon",
    i18n: "Users",
    show: canViewUserManagement()
  },
  {
    url: "/investors",
    name: "Investors",
    slug: "RaqmanaInvestors",
    icon: "UsersIcon",
    i18n: "Investors",
    show: canViewCorePages()
  },
  {
    url: "/PropertyOwners",
    name: "Property Owners",
    slug: "RaqmanaPropertyOwners",
    icon: "UsersIcon", 
    i18n: "PropertyOwners",
    show: canViewCorePages()
  },
  {
    url: "/properties",
    show: true,
    name: "Properties",
    slug: "RaqmanaProperties",
    icon: "HomeIcon",
    i18n: "Properties",
    show: canViewCorePages()
  },
  {
    url: "/opportunities",
    name: "Opportunities",
    slug: "RaqmanaOpportunities",
    icon: "GridIcon",
    i18n: "Opportunities",
    show: canViewCorePages()
  },
  {
    url: "/tokens",
    name: "Tokens",
    slug: "Tokens",
    icon: "HexagonIcon",
    i18n: "Tokens",
    show: canViewCorePages()
  },
  {
    url: "/PurchaseOrders",
    name: "Purchase Orders",
    slug: "RaqmanaPurchaseOrders",
    icon: "ShoppingCartIcon",
    i18n: "PurchaseOrders",
    show: canViewCorePages()
  },
  {
    url: "/complaintSuggestions",
    name: "Complaint Suggestions",
    slug: "RaqmanaComplaintSuggestions",
    icon: "MessageSquareIcon",
    i18n: "ComplaintSuggestions",
    show: canViewCorePages()
  },
  {
    url: "/Reports",
    name: "Reports  ",
    slug: "Reports",
    icon: "BarChartIcon",
    i18n: "RecordsReports"
  },
  {
    url: null,
    name: "Settings",
    slug: "Settings",
    icon: "SettingsIcon",
    i18n: "Settings",
    show: canViewLookups(),
    submenu: [
      {
        url: "/settings/countries",
        name: "Countries",
        slug: "SettingsCountries",
        icon: "GridIcon",
        i18n: "Countries",
        show: canViewLookups()
      },
      {
        url: "/settings/regions",
        name: "Regions",
        slug: "SettingsRegions",
        icon: "GridIcon",
        i18n: "Regions",
        show: canViewLookups()
      },
      {
        url: "/settings/cities",
        name: "Cities",
        slug: "SettingsCities",
        icon: "GridIcon",
        i18n: "Cities",
        show: canViewLookups()
      },
      {
        url: "/settings/districts",
        name: "Districts",
        slug: "SettingsDistricts",
        icon: "GridIcon",
        i18n: "Districts",
        show: canViewLookups()
      },
      {
        url: "/settings/nationalities",
        name: "Nationalities",
        slug: "SettingsNationalities",
        icon: "GridIcon",
        i18n: "Nationalities",
        show: canViewLookups()
      },
      {
        url: "/settings/investor-categories",
        name: "Investor Categories",
        slug: "SettingsInvestorCategories",
        icon: "GridIcon",
        i18n: "InvestorCategories",
        show: canViewLookups()
      },
      {
        url: "/settings/property-types",
        name: "Property Types",
        slug: "SettingsPropertyTypes",
        icon: "GridIcon",
        i18n: "PropertyTypes",
        show: canViewLookups()
      },
      {
        url: "/settings/wallet-transaction-types",
        name: "Wallet Transaction Types",
        slug: "SettingsWalletTransactionTypes",
        icon: "GridIcon",
        i18n: "WalletTransactionTypes",
        show: canViewLookups()
      },
      {
        url: "/settings/payment-method-types",
        name: "Payment Method Types",
        slug: "SettingsPaymentMethodTypes",
        icon: "GridIcon",
        i18n: "PaymentMethodTypes",
        show: canViewLookups()
      },
      {
        url: "/settings/investor-kyc-statuses",
        name: "Investor KYC Statuses",
        slug: "SettingsInvestorKycStatuses",
        icon: "GridIcon",
        i18n: "InvestorKycStatuses",
        show: canViewLookups()
      },
      {
        url: "/settings/wallet-statuses",
        name: "Wallet Statuses",
        slug: "SettingsWalletStatuses",
        icon: "GridIcon",
        i18n: "WalletStatuses",
        show: canViewLookups()
      },
      {
        url: "/settings/property-listing-statuses",
        name: "Property Listing Statuses",
        slug: "SettingsPropertyListingStatuses",
        icon: "GridIcon",
        i18n: "PropertyListingStatuses",
        show: canViewLookups()
      },
      {
        url: "/settings/opportunity-statuses",
        name: "Opportunity Statuses",
        slug: "SettingsOpportunityStatuses",
        icon: "GridIcon",
        i18n: "OpportunityStatuses",
        show: canViewLookups()
      },
      {
        url: "/settings/token-statuses",
        name: "Token Statuses",
        slug: "SettingsTokenStatuses",
        icon: "GridIcon",
        i18n: "TokenStatuses",
        show: canViewLookups()
      },
      {
        url: "/settings/purchase-order-statuses",
        name: "Purchase Order Statuses",
        slug: "SettingsPurchaseOrderStatuses",
        icon: "GridIcon",
        i18n: "PurchaseOrderStatuses",
        show: canViewLookups()
      },
      {
        url: "/settings/wallet-transaction-statuses",
        name: "Wallet Transaction Statuses",
        slug: "SettingsWalletTransactionStatuses",
        icon: "GridIcon",
        i18n: "WalletTransactionStatuses",
        show: canViewLookups()
      },
      {
        url: "/settings/notification-types",
        name: "Notification Types",
        slug: "SettingsNotificationTypes",
        icon: "GridIcon",
        i18n: "NotificationTypes",
        show: canViewLookups()
      },      
    ]
  }
];
